interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
  helperText?: string
}

export default function Textarea({ label, error, helperText, className = '', ...props }: TextareaProps) {
  return (
    <div className="flex flex-col gap-2">
      {label && (
        <label className="text-label uppercase tracking-widest text-foreground">
          {label}
        </label>
      )}
      <textarea
        className={`px-4 py-3 bg-surface-1 border ${
          error ? 'border-error' : 'border-border focus:border-primary'
        } text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary transition-colors min-h-[120px] resize-y ${className}`}
        {...props}
      />
      {error && (
        <span className="text-label text-error">{error}</span>
      )}
      {helperText && !error && (
        <span className="text-label text-muted-foreground">{helperText}</span>
      )}
    </div>
  )
}